import { HeroUIProvider } from '@heroui/react';
import { ReactNode } from 'react';
import { ToastProvider } from '@shared/components/Toast';
import { ModalProvider } from '@ui/Modal';

interface Props {
  children: ReactNode;
}

export function UIProvider({ children }: Props) {
  return (
    <HeroUIProvider style={{ display: 'contents' }}>
      <ModalProvider>
        <ToastProvider>{children}</ToastProvider>
      </ModalProvider>
    </HeroUIProvider>
  );
}
